module.exports = __webpack_public_path__ + "img/yellowWrap.3a98564d.png";